<template>
  <div class="interaction">
      <div class="apparel">
        <div class="center">
        <div class="exchange">
          <h2>Human-Computer Interaction<br /> Empowering AI</h2>
          <p>Emotional interaction between bionic robots and smart wearables.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "interaction.vue"
}
</script>

<style scoped>

.interaction {
}

 .apparel {
   background-image: url("../../../assets/provide-img.png");
   background-repeat: no-repeat;
   background-position: right;
   height: 900px;
 }

 .apparel .center {
   width: 1200px;
   margin: 0 auto;
 }

 .apparel .exchange {
   padding-top: 330px;
}

 .apparel .exchange h2 {
   font-style: normal;
   font-weight: 700;
   font-size: 46px;
   line-height: 80px;
  color: #111111;
}

 .apparel .exchange p {
   margin-top:50px;
   width: 643px;
   font-style: normal;
   font-weight: 400;
   font-size: 24px;
   line-height: 50px;
  color: #999999;
}

</style>
